import { ProjectLayout, loadProjectOverview } from "@/components/projects/project-layout";
import { createFileRoute } from "@tanstack/react-router";

/**
 * `/{group}/{project}` — the GitLab-native project layout. The
 * second URL segment is the project slug (globally unique); the
 * group segment is decorative, mirroring GitLab's own URLs. Reuses
 * the same layout + loader as the internal `/projects/{slug}`
 * route so both URL shapes render identically.
 */
export const Route = createFileRoute("/_app/$group/$project")({
  loader: ({ params }) => loadProjectOverview(params.project),
  component: GitlabNativeProjectLayout,
});

function GitlabNativeProjectLayout() {
  return <ProjectLayout data={Route.useLoaderData()} />;
}
